/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_NoteInputs */

const en_landing_drift_note = /** @type {(inputs: Landing_Drift_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measured pixel-by-pixel on the lossless files; images on this page are compressed for speed.`)
};

const zh_landing_drift_note = /** @type {(inputs: Landing_Drift_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于无损原图逐像素测量；页面展示图为加载速度做了压缩。`)
};

/**
* | output |
* | --- |
* | "Measured pixel-by-pixel on the lossless files; images on this page are compressed for speed." |
*
* @param {Landing_Drift_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_note = /** @type {((inputs?: Landing_Drift_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_note(inputs)
	return zh_landing_drift_note(inputs)
});
export { landing_drift_note as "landing.drift.note" }